<template>
  <div>
    <DataTable :value="data" v-model:filters="filtre" :globalFilterFields="FilterFilelds" responsiveLayout="scroll"
      :scrollable="true" size="small" :paginator="true" :rows="10" :rowsPerPageOptions="[10, 20, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" :dataKey="datakey" resizableColumns
      columnResizeMode="fit" ref="dataTable" showGridlines stripedRows sortMode="multiple" removableSort
      v-model:selection.sync="selectedrows" @row-select="onRowSelect" @row-unselect="onRowUnselect">
      <!--columnResizeMode="expand" -->
      <template #empty> Veri Bulunamadı. </template>
      <template #loading> Yükleniyor. Lüften Bekleyin. </template>
      <template #header>
        <div class="grid">
          <div class="text-left col-6">
            <Button icon="pi pi-external-link" label="Export" class="button-raised button-rounded" size="small"
              @click="exportCSV($event)" />
          </div>
          <div class="text-right col-4"></div>
          <div class="text-right col-2">
            <InputGroup>
              <InputGroupAddon>
                <i class="pi pi-search"></i>
              </InputGroupAddon>
              <InputText placeholder="Ara" v-model="filtre['global'].value" size="small" />
            </InputGroup>
          </div>
        </div>
      </template>
      <Column v-if="selectionmode" :frozen="true" selectionMode="multiple" :exportable="false"
        style="max-width: 2.5rem;">
      </Column>

      <Column sortable v-for="col of columns" :field="col.field" :header="col.header" :key="col.RowId">
      </Column>

      <Column sortable header="Durum" field="Durum" :filterMenuStyle="{ width: '12rem' }" style="min-width: 10rem">
        <template #body="{ data }">
          <Tag :value="data.Durum" :severity="getSeverity(data.Durum)" />
        </template>
      </Column>

      <Column v-if="detailbutton" :exportable="false" style="max-width: 1rem">
        <template #body="slotProps">
          <div style="display: flex; justify-content: center;">
            <Button icon="pi pi-file-edit" severity="warn" size="small" rounded @click="_edit(slotProps)" />
          </div>
        </template>
      </Column>
      <Column v-if="deletebutton" :exportable="false" style="max-width: 1rem">
        <template #body="slotProps">
          <div style="display: flex; justify-content: center;">
            <Button icon="pi pi-trash" severity="danger" size="small" rounded @click="_delete(slotProps)" />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import { FilterMatchMode } from '@primevue/core/api';

export default {
  props: {
    columns: Array,
    data: Array,
    selectionmode: Boolean,
    datakey: String,
    detailbutton: { default: true, type: Boolean },
    deletebutton: { default: false, type: Boolean }
  },
  data() {
    return {
      filtre: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      FilterFilelds: [],
      selectedrows: []
    };
  },
  methods: {
    _delete(DeleteRowData) {
      this.$emit("delete-child-data", DeleteRowData);
    },
    _edit(EditRowData) {
      this.$emit("set-child-data", EditRowData);
    },
    onRowSelect() {
      this.$emit("selected_rows", this.selectedrows);
    },
    onRowUnselect() {
      this.$emit("selected_rows", this.selectedrows);
    },
    getSeverity(status) {
      switch (status) {
        case "Aktif":
          return "success";
        case "Pasif":
          return "danger";
        //
        case "Yetkili":
          return "success";
        case "Yetkisiz":
          return "danger";
        //
        case null:
          return null;
      }
    },
  },
  mounted() {
    for (let index = 0; index < this.columns.length; index++) {
      this.FilterFilelds.push(this.columns[index].field);
    }
    window.$('.datatable-thead').css("z-index", "0");
    this.$emit("selected_rows", this.selectedrows);
  },
  created() { },
};
</script>
